import { createContext, useState } from 'react';

export const IncPageContext = createContext();

const IncPageProvider = ({ children }) => {
  const [hasFooter, setHasFooter] = useState(false);

  const value = { hasFooter, setHasFooter };

  return (
    <IncPageContext.Provider value={value}>{children}</IncPageContext.Provider>
  );
};

export default IncPageProvider;
